import AgGridColumnHeader from '@/components/AgGrid/components/ColumnHeader';
import AgDateFilter from '@/components/AgGrid/components/AgDateFilter/AgDateFilterBE';
import StatusCell from '@/pages/company/BankFeedRoute/components/cellRenderers/StatusCell';
import AccountCellRenderer from '@/pages/company/BankFeedRoute/components/cellRenderers/AccountCellRenderer';
import AmountCell from '@/pages/company/BankFeedRoute/components/cellRenderers/AmountCell';
import BankFeedSetColumnFilter from '@/pages/company/BankFeedRoute/components/BankFeedGrid/BankFeedSetColumnFilter';
import BankFeedSumStatusPanel from '@/pages/company/BankFeedRoute/components/BankFeedGrid/BankFeedSumStatusPanel';

// `agColumnHeader` — reserved AG Grid key. Overriding the default header so it matches the rest
// of the app (tooltips, hint icon, custom filter-button styling).
// `customDateFilter` — shared server-side date filter, same component the Workspace grid uses
// (mapped by type `date` in BankFeedTransactions/filterHelpers.ts).
const gridComponents = {
  statusCell: StatusCell,
  accountCellRenderer: AccountCellRenderer,
  amountCell: AmountCell,
  agColumnHeader: AgGridColumnHeader,
  bankFeedSetColumnFilter: BankFeedSetColumnFilter,
  customDateFilter: AgDateFilter,
  bankFeedSumStatusPanel: BankFeedSumStatusPanel,
} as const;

export default gridComponents;
